import RegistrationForm from "../components/RegistrationForm";

function Registration() {
  document.title = "TicketBlaster | Event Details";

  return <RegistrationForm />;
}

export default Registration;
